import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { BiData } from '@wix/da-bi/pkg/events';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import ScrollIcon from '@wix/da-ds/pkg/Icons/24x24/Scroll';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import VisuallyHidden from '@wix/da-a11y/pkg/components/VisuallyHidden';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import noop from '../../utils/noop';
import EmptyBackground from '../../DeviationBackground/StageBackground/EmptyBackground';
import { useMobileStage } from '../hooks/useMobileStage';
import AdditionalMediaSlider from '../_partials/AdditionalMediaSlider';
import FullImageSourceWithCaption from '../_partials/FullImageSourceWithCaption';
import { BI_CAROUSEL_SECTIONNAME } from '../constants';
import cn from 'classnames';
import styles from './MobileArtStage.scss';
const CURRENT_IMAGE_MAX_HEIGHT = 363;
/** Multi-image deviation that displays as a slider of thumbnails allowing the user
 *  to choose what image is displayed in a larger single image above.
 *
 *  Also currently the only multi-image stage that correctly shows mature, paywall
 *  blocking. */ const MobileMultiArtCarouselStage = ({ deviation, additionalMedia, disabled, shouldBlur, currentlyViewedImageSource, setCurrentlyViewedImageSource = noop, isZoomed, onEnterZoomMode = noop, onExitZoomMode = noop, setDisplayMode = noop })=>{
    const { t } = useTranslation();
    const { contentSize = {} } = useMobileStage(deviation);
    const cappedCurrentImageHeight = Math.min(contentSize.height, CURRENT_IMAGE_MAX_HEIGHT);
    return /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: BI_CAROUSEL_SECTIONNAME
    }, /*#__PURE__*/ React.createElement(EmptyBackground, null), /*#__PURE__*/ React.createElement(FullImageSourceWithCaption, {
        deviationOrAttachment: currentlyViewedImageSource ? currentlyViewedImageSource : deviation,
        width: contentSize.width,
        height: cappedCurrentImageHeight,
        withoutZoomModal: true,
        isZoomed: isZoomed,
        onEnterZoomMode: onEnterZoomMode,
        onExitZoomMode: onExitZoomMode
    }), /*#__PURE__*/ React.createElement(Section, {
        className: styles['carousel-controls']
    }, /*#__PURE__*/ React.createElement(VisuallyHidden, null, /*#__PURE__*/ React.createElement(Heading, null, t('deviationview.artstage.multi.carouselControls.a11yHeading'))), /*#__PURE__*/ React.createElement(AdditionalMediaSlider, {
        className: cn(styles['additional-media-slider'], 'additional-slider'),
        // different than desktop
        thumbSize: 48,
        deviation: deviation,
        additionalMedia: additionalMedia,
        disabled: disabled,
        shouldBlur: shouldBlur,
        selected: currentlyViewedImageSource,
        onSelect: (attachment)=>setCurrentlyViewedImageSource(attachment)
    }), deviation.extended && /*#__PURE__*/ React.createElement(IconButton, {
        className: styles['switch-to-scroll-button'],
        icon: ScrollIcon,
        size: "large",
        "aria-label": t('deviationview.artstage.changeToScrollMode.altLabel'),
        disabled: disabled,
        onClick: ()=>setDisplayMode('scroll'),
        biData: BiData({
            evid: 309,
            deviationid: deviation.deviationId,
            view_mode: 'scroll'
        })
    })));
};
MobileMultiArtCarouselStage.displayName = 'MobileMultiArtCarouselStage';
export default MobileMultiArtCarouselStage;

//# sourceMappingURL=MobileMultiArtCarouselStage.js.map